import * as React from 'react';

const SvgComponent = props => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlSpace='preserve'
		width={253.286}
		height={223.771}
		viewBox='0 0 67.015 59.206'
		{...props}>
		<path
			d='m135.326 75.58-14.934 17.278.18 21.595-9.36 5.396-.406-24.815 13.48-17.39z'
			style={{
				fill: '#6f918a',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
		<path
			d='m93.043 63.493 7.553 11.73 8.818-9.898 15.477 14.036-14.037 15.657.36 24.834-21.235-4.5V92.679L79.36 74.682Z'
			style={{
				fill: '#ff8080',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
		<path
			d='m109.414 65.346 9.538-2.9 16.376 13.136-10.449 3.79zM93.038 63.491c1.08-.18 9.898-2.845 9.898-2.845l4.801 6.59-7.152 8.003z'
			style={{
				fill: '#6f918a',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
		<path
			d='M92.183 89.574c-1.407 2.942.218 6.05 1.845 7.603l5.691-5.601Z'
			style={{
				fill: '#cf0',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
		<path
			d='M92.183 89.563c1.66 1.397 2.514 5.175 1.856 7.603 0 0-1.524-.728-2.167-3.468-.642-2.74.311-4.135.311-4.135z'
			style={{
				fill: '#8a0',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
		<path
			d='M68.46 98.364c.318-.127 24.154-5.893 24.154-5.893.638.474.742 1.333.596 2.067l-24.177 5.925c-.802-.572-.78-1.317-.573-2.1z'
			style={{
				fill: '#cf0',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
		<path
			d='M68.46 98.372c.511.225.84 1.654.567 2.099-.268-.085-.546-.418-.654-.946-.109-.528-.063-1.014.087-1.153z'
			style={{
				fill: '#8a0',
				strokeWidth: 0.264583
			}}
			transform='translate(-68.313 -60.646)'
		/>
	</svg>
);

export default SvgComponent;
